export default __webpack_public_path__ + "966b560fbcf4d2f30e4fa02856a805e2.svg";